import { ReactComponent as OB } from "../../img/icon-online.svg";
import { ReactComponent as SB } from "../../img/icon-budgeting.svg";
import { ReactComponent as FO } from "../../img/icon-onboarding.svg";
import { ReactComponent as OA } from "../../img/icon-api.svg";
export const featureLists = [
    {
        id: 1,
        icon: <OB />,
        title: "Online Banking",
        text: "Our modern web and mobile applications allow you to keep track of your finances wherever you are in the world.",
    },
    {
        id: 2,
        icon: <SB />,
        title: "Simple Budgeting",
        text: "See exactly where your money goes each month. Receive notifications when you’re close to hitting your limits.",
    },
    {
        id: 3,
        icon: <FO />,
        title: "Fast Onboarding",
        text: "We don’t do branches. Open your account in minutes online and start taking control of your finances right away.",
    },
    {
        id: 4,
        icon: <OA />,
        title: "Open API",
        text: "Manage your savings, investments, pension, and much more from one account. Tracking your money has never been easier.",
    },
];
